import { render, staticRenderFns } from "./iCcard.vue?vue&type=template&id=754b0777&scoped=true&"
import script from "./iCcard.vue?vue&type=script&lang=js&"
export * from "./iCcard.vue?vue&type=script&lang=js&"
import style0 from "./iCcard.vue?vue&type=style&index=0&id=754b0777&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b0777",
  null
  
)

export default component.exports